import request from '@/utils/request'

let RecommendApi = {
    /*获取数据*/
    getData(data) {
        return request._get('/shop/plus.recommend/index', data);
    },
    /*保存数据*/
    saveData(data) {
        return request._post('/shop/plus.recommend/index', data);
    },
}
export default RecommendApi;



// WEBPACK FOOTER //
// ./src/api/recommend.js